import {
  Create,
  SimpleForm,
  TextInput,
  NumberInput,
  useNotify,
  useRedirect,
  useDataProvider,
  SelectInput,
  
} from "react-admin";

import {
  Box,
  Tabs,
  Tab,
  Select,
  MenuItem,
  Checkbox,
  Typography,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Chip,
  Divider,
  IconButton,
  Radio,
  RadioGroup,
  FormControlLabel,
} from "@mui/material";
import { minValue, maxValue } from "react-admin";
import { usePermissions } from "react-admin";

import CloseIcon from "@mui/icons-material/Close";

import { useEffect, useState } from "react";
import { apiUrl } from "../apiendpoint";
import { CKEditor } from "@ckeditor/ckeditor5-react";
import ClassicEditor from "@ckeditor/ckeditor5-build-classic";

const AssessmentCreate = () => {
  const { permissions = [] } = usePermissions();
  const notify = useNotify();
  const redirect = useRedirect();
  const dataProvider = useDataProvider();
  const [tab, setTab] = useState(0);

  const [image, setImage] = useState("");
  const [imagePreview, setImagePreview] = useState("");
  const [uploading, setUploading] = useState(false);
  const [certificates, setCertificates] = useState([]);

  // Preview
  const [previewQuestion, setPreviewQuestion] = useState(null);
  const [previewLoading, setPreviewLoading] = useState(false);

  // QUESTIONS
  const [questions, setQuestions] = useState([]);
  const [selectedQuestions, setSelectedQuestions] = useState([]);
  const [totalScore, setTotalScore] = useState(0);

  const [instructions, setInstructions] = useState(
    "<li>Kindly Update your profile picture and details before attempting the assessment.</li>"
  );

  // FILTERS
  const [category, setCategory] = useState("");
  const [subcategory, setSubcategory] = useState("");
  const [difficulty, setDifficulty] = useState("");

  // CATEGORY DATA
  const [categories, setCategories] = useState([]);

  // FETCH CATEGORIES
  useEffect(() => {
    const fetchCategories = async () => {
      const { data } = await dataProvider.getList("categories", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
      });
      setCategories(data);
    };

    fetchCategories();
  }, [dataProvider]);

useEffect(() => {
  const fetchCertificates = async () => {
    try {

      const { data } = await dataProvider.getList("certificate", {
        pagination: { page: 1, perPage: 100 },
        sort: { field: "id", order: "ASC" },
      });

      console.log("CERTIFICATES =", data);

      setCertificates(data || []);

    } catch (err) {
      console.error(err);
    }
  };

  fetchCertificates();
}, [dataProvider]);

  const categoryOptions = [
    ...new Set(categories.map((c) => c.category_name)),
  ];

  const validateForm = () => {
  if (selectedQuestions.length === 0) {
    return {
      _error: "Please select at least one question",
    };
  }
  return {};
};
  const subcategoryOptions = categories
    .filter((c) => c.category_name === category)
    .map((c) => ({
      id: c.id,
      name: c.subcategory_name,
    }));

  // FETCH QUESTIONS
  const fetchQuestions = async () => {
  const token = localStorage.getItem("access_token");

  const query = {
    filter: JSON.stringify({
      category_name: category || undefined,
      subcategory_name: subcategory || undefined,
      difficulty_level: difficulty || undefined,
    }),
    range: JSON.stringify([0, 50]),
  };

  const res = await fetch(
    `${apiUrl}questions?${new URLSearchParams(query)}`,
    {
      method: "GET",
      headers: {
        "Content-Type": "application/json",
        Authorization: `Bearer ${localStorage.getItem("access_token")}`,
      },
    }
  );

  const data = await res.json();

  setQuestions(data);
};

  useEffect(() => {
    if (tab === 1) fetchQuestions();
  }, [tab, category, subcategory, difficulty]);

  if (
    !(
      permissions.includes("assessments.create") ||
      permissions.includes("assessments.*") ||
      permissions.includes("*")
    )
  ) {
    return null;
  }

  


  // SELECT QUESTION
const handleSelect = (q) => {
  let updated;

  if (selectedQuestions.some((item) => item.id === q.id)) {
    updated = selectedQuestions.filter(
      (item) => item.id !== q.id
    );
  } else {
    updated = [...selectedQuestions, q];
  }

  setSelectedQuestions(updated);

  // ✅ FIX TOTAL SCORE
  const total = updated.reduce((sum, item) => {
    return (
      sum +
      Number(
        item.question_data?.marks ||
        item.marks ||
        0
      )
    );
  }, 0);

  setTotalScore(total);
};

  // PREVIEW QUESTION — opens modal
  const handlePreview = async (q) => {
    setPreviewLoading(true);
    setPreviewQuestion(null);
    try {
      const res = await fetch(`${apiUrl}questions/${q.id}`,{
        headers: {Authorization: `Bearer ${localStorage.getItem("access_token")}`},
      });
      const data = await res.json();
      setPreviewQuestion(data);
    } catch (err) {
      console.error(err);
      notify("Failed to load question preview", { type: "error" });
    } finally {
      setPreviewLoading(false);
    }
  };

  const validateDuration = (value) => {
    if (!value) return "Required";
    if (value < 5) return "Minimum 5 minutes required";
    if (value > 180) return "Maximum 180 minutes allowed";
    return undefined;
};

 const handleImageUpload = async (e) => {
  const file = e.target.files[0];

  if (!file) return;

  // local preview
  setImagePreview(URL.createObjectURL(file));

  const formData = new FormData();
  formData.append("file", file);

  try {
    setUploading(true);
    const token = localStorage.getItem("access_token");
    const res = await fetch(
      `${apiUrl}upload-image`,{
     
        method: "POST",
        body: formData,
        headers:{

        Authorization: `Bearer ${token}`,
      }
    }
    );

    const data = await res.json();

    console.log(data);

    // save image path from backend
    setImage(data.image_url);

    notify("Image uploaded successfully", {
      type: "success",
    });

  } catch (err) {
    notify("Image upload failed", {
      type: "error",
    });
  } finally {
    setUploading(false);
  }
};

  const handleClosePreview = () => {
    setPreviewQuestion(null);
  };

  const handleAddFromPreview = () => {
    if (previewQuestion) {
      handleSelect(previewQuestion);
    }
    handleClosePreview();
  };

  const handleClearSelection = () => {
    setSelectedQuestions([]);
    setTotalScore(0);
  };

  const isSelectedInPreview =
    previewQuestion &&
    selectedQuestions.some((s) => s.id === previewQuestion.id);

  const clearFilters = () => {
    setCategory("");
    setSubcategory("");
    setDifficulty("");
  };

  // TRANSFORM
  const transform = (values) => {
    const categoryIds = selectedQuestions.flatMap(
      (q) => q.assessment_category_ids || []
    );

    const uniqueCategoryIds = [...new Set(categoryIds)];
    console.log("IMAGE VALUE =", image);

    

    return {
      ...values,
      instructions,
      question_bank_ids: selectedQuestions.map((q) => q.id),
      total_score: totalScore,
      //  CORE LOGIC HERE
      passing_score: Math.ceil(
      (Number(values.passing_score || 0) / 100) * totalScore
    ),
      assessment_category_ids: uniqueCategoryIds,
      image: image,
      
    };
  };

  return (
    <Create
      title="Create Assessment"
      transform={transform}
      mutationOptions={{
        onSuccess: () => {
          notify("Assessment created 🎉", { type: "success" });
          redirect("/assessments");
        },
      }}
    >
      <SimpleForm validate={validateForm}>
        {/* TABS */}
        <Tabs value={tab} onChange={(e, v) => setTab(v)}>
          <Tab label="Assessment" />
          <Tab label="Select Questions" />
          <Tab label="Instructions" />
          <Tab label="Upload Image and Certificate" /> 
        </Tabs>

        {/* TAB 1 — Assessment Details */}
        {tab === 0 && (
          <Box mt={3}>
            <Paper sx={{ p: 3, borderRadius: 2, maxWidth: "600px", mx: "auto" }}>
              
              <TextInput source="title" fullWidth required />
              <TextInput source="description" fullWidth multiline />
              <Box display="flex" gap={2}>
                <NumberInput
                  source="passing_score"
                  label="Passing Score (%)"
                  fullWidth
                  onWheel={(e) => e.target.blur()}
                  required
                  min={0}
                  max={100}
/>
                

                

                <NumberInput
                  source="duration"
                  label="Duration (minutes)"
                  fullWidth
                  required
                  validate={validateDuration}
                  inputProps={{ min: 5, max: 180 }}
                  onWheel={(e) => e.target.blur()}

                  // ✅ ONLY for value correction
                  parse={(value) => {
                    if (value === "") return value;

                    let num = Number(value);

                    if (num < 5) return 5;
                    if (num > 180) return 180;

                    return num;
                  }}

                  // ✅ Popup ONLY once when user leaves field
                  onBlur={(e) => {
                    const value = Number(e.target.value);

                    if (value < 5) {
                      notify("Minimum duration is 5 minutes", { type: "warning" });
                    }

                    if (value > 180) {
                      notify("Maximum duration is 180 minutes", { type: "warning" });
                    }
                  }}
                />
              </Box>
            </Paper>
          </Box>  
        )}

        {/* TAB 2 — Select Questions */}
        {tab === 1 && (
          <Box mt={2}>
            {/* FILTERS */}
            <Box sx={{ display: "flex", gap: 2, mb: 2, flexWrap: "wrap" }}>
              <Select
                value={category}
                onChange={(e) => {
                  setCategory(e.target.value);
                  setSubcategory("");
                }}
                displayEmpty
                size="small"
              >
                <MenuItem value="">Category</MenuItem>
                {categoryOptions.map((cat) => (
                  <MenuItem key={cat} value={cat}>
                    {cat}
                  </MenuItem>
                ))}
              </Select>

              <Select
                value={subcategory}
                onChange={(e) => setSubcategory(e.target.value)}
                displayEmpty
                size="small"
              >
                <MenuItem value="">Subcategory</MenuItem>
                {subcategoryOptions.map((sub) => (
                  <MenuItem key={sub.id} value={sub.name}>
                    {sub.name}
                  </MenuItem>
                ))}
              </Select>

              <Select
                value={difficulty}
                onChange={(e) => setDifficulty(e.target.value)}
                displayEmpty
                size="small"
              >
                <MenuItem value="">Difficulty</MenuItem>
                <MenuItem value="easy">Easy</MenuItem>
                <MenuItem value="medium">Medium</MenuItem>
                <MenuItem value="hard">Hard</MenuItem>
              </Select>

              <Button variant="outlined" size="small" onClick={clearFilters}>
                Clear
              </Button>
            
            <Button
              onClick={handleClearSelection}
              variant="outlined"
              size="small"
            >
              Clear Selection
            </Button> 
            </Box>
            {selectedQuestions.length === 0 && (
              <Typography color="error" sx={{ mb: 2 }}>
                Please select at least one question
              </Typography>
            )}

            {/* QUESTION LIST */}
            <Paper sx={{ maxHeight: 400, overflow: "auto" }}>
              {questions.length === 0 && (
                <Typography sx={{ p: 2, color: "text.secondary" }}>
                  No questions found.
                </Typography>
              )}

              {questions.map((q) => {
  const isSelected = selectedQuestions.some((s) => s.id === q.id);

  return (
    <Box
      key={q.id}
      sx={(theme) => ({
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        p: 2,
        borderBottom: "1px solid",
        borderColor: "divider",

        // ✅ SELECTED STYLE (theme aware)
        backgroundColor: isSelected
          ? theme.palette.action.selected
          : "transparent",

        color: "text.primary",

        borderRadius: 1,

        // ✅ LEFT BORDER (nice UX)
        borderLeft: isSelected
          ? `4px solid ${theme.palette.primary.main}`
          : "4px solid transparent",

        // ✅ HOVER (theme aware)
        "&:hover": {
          backgroundColor: isSelected
            ? theme.palette.action.selected
            : theme.palette.action.hover,
        },

        transition: "all 0.2s ease",
      })}
    >
                  <Box display="flex" gap={1} alignItems="center" flex={1}
                  sx={{
                        cursor: "pointer",
                        "&:hover": { color: "primary.main", textDecoration: "underline" },
                        flex: 1,
                      }}
                      onClick={() => handlePreview(q)}
                  >
                    <Checkbox
                      checked={selectedQuestions.some((s) => s.id === q.id)}
                      onClick={(e) => e.stopPropagation()}
                      onChange={() => handleSelect(q)}
                    />

                    <Typography
                      
                    >
                      {q.title}
                    </Typography>
                  </Box>

                  <Box display="flex" gap={2} alignItems="center" ml={2}>
                    <Typography variant="body2" color="text.secondary">
                      {q.marks} Marks
                    </Typography>
                    <Button
                      size="small"
                      variant="outlined"
                      onClick={() => handlePreview(q)}
                    >
                      Preview
                    </Button>
                  </Box>
                </Box>
              )})}
            </Paper>

            {/* BOTTOM BAR */}
            <Box mt={2} sx={{ display: "flex", justifyContent: "space-between" }}>
              <Typography variant="h6">
                Total Questions: {selectedQuestions.length}
              </Typography>
              <Typography variant="h6">
                Total Score: {totalScore}
              </Typography>
            </Box>
          </Box>
        )}

        {/* TAB 3 — Instructions */}
          {tab === 2 && (
            <Box mt={3} >
              <Paper
                sx={{
                  p: 3,
                  borderRadius: 2, 
                  maxWidth: "900px",
                  mx: "auto",
                  "& .ck-editor__editable": {
                    minHeight: "300px",
                    maxHeight: "500px",
                    overflowY: "auto",
                  },
                }}
              >
      <Typography variant="h6" mb={2} fontWeight={600}>
        Assessment Instructions
      </Typography>

      <Typography variant="body2" color="text.secondary" mb={2}>
        These instructions will be shown to candidates before they start the test.
      </Typography>

      <CKEditor
        editor={ClassicEditor}
        data={instructions}
        config={{
          toolbar: [
            "heading",
            "|",
            "bold",
            "italic",
            "underline",
            "|",
            "bulletedList",
            "numberedList",
            "|",
            "link",
            "blockQuote",
            "|",
            "undo",
            "redo",
          ],
        }}
        onChange={(event, editor) =>
          setInstructions(editor.getData())
        }
      />
    </Paper>
  </Box>
)}

{/* TAB 4 — Upload Image & Certificate */}
{tab === 3 && (
  <Box
    mt={4}
    display="flex"
   
    width="50%"
    justifyContent="center"
    alignItems="center"
  >
    <Paper
      sx={{
        justifyContent: "center",
       
        alignContent: "center",
        alignItems: "center",
        width: "100%",
        maxWidth: "850px",
        p: 4,
        borderRadius: "20px",
      }}
    >
      {/* PAGE TITLE */}
      <Typography
        variant="h5"
        fontWeight={700}
        mb={1}
      >
        Assessment Settings
      </Typography>

      <Typography
        variant="body2"
        color="text.secondary"
        mb={4}
      >
        Upload assessment thumbnail and assign certificate.
      </Typography>

      {/* ================= IMAGE SECTION ================= */}
      <Box mb={5}>
        <Typography
          variant="h6"
          fontWeight={600}
          mb={2}
        >
          Upload Assessment Image
        </Typography>

        {/* IMAGE PREVIEW */}
        <Box
          sx={{
            width: "100%",
            height: 250,
            border: "2px dashed #555",
            borderRadius: "16px",
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            overflow: "hidden",
            backgroundColor: "background.default",
            mb: 3,
          }}
        >
          {imagePreview ? (
            <img
              src={imagePreview}
              alt="preview"
              style={{
                width: "100%",
                height: "100%",
                objectFit: "cover",
              }}
            />
          ) : (
            <Typography color="text.secondary">
              No image selected
            </Typography>
          )}
        </Box>

        {/* UPLOAD BUTTON */}
        <Button
          variant="contained"
          component="label"
          size="large"
        >
          {uploading ? "Uploading..." : "Choose Image"}

          <input
            type="file"
            hidden
            accept="image/*"
            onChange={handleImageUpload}
          />
        </Button>
      </Box>

      {/* ================= CERTIFICATE SECTION ================= */}
      <Box>
        <Typography
          variant="h6"
          fontWeight={600}
          mb={2}
        >
          Assign Certificate
        </Typography>

        <Typography
          variant="body2"
          color="text.secondary"
          mb={3}
        >
          Select certificate users will receive after passing assessment.
        </Typography>

        <Box maxWidth={400}>
          <SelectInput
            source="certificate_id"
            label="Select Certificate"
            choices={certificates.map((c) => ({
              id: c.id,
              name: c.course_name,
            }))}
            fullWidth
            emptyText="No Certificate"
          />
        </Box>
      </Box>
    </Paper>
  </Box>
)}
      </SimpleForm>

      {/* ✅ QUESTION PREVIEW MODAL */}
      <Dialog
        open={!!previewQuestion || previewLoading}
        onClose={handleClosePreview}
        maxWidth="sm"
        fullWidth
        PaperProps={{ sx: { borderRadius: 2 } }}
      >
        <DialogTitle
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            pb: 1,
          }}
        >
          <Typography variant="h6" fontWeight={600}>
            Question Preview
          </Typography>
          <IconButton onClick={handleClosePreview} size="small">
            <CloseIcon fontSize="small" />
          </IconButton>
        </DialogTitle>

        <Divider />

        <DialogContent>
          {previewLoading && (
            <Typography color="text.secondary">Loading...</Typography>
          )}

          {previewQuestion && (
            <>
              {/* Question Text */}
              <Box mb={2}>
                <div
                  dangerouslySetInnerHTML={{
                    __html:
                      previewQuestion.question_data?.question_text ||
                      previewQuestion.title ||
                      "No content",
                  }}
                />
              </Box>

              {/* Badges */}
              <Box display="flex" gap={1} flexWrap="wrap" mb={2}>
                {previewQuestion.difficulty_level && (
                  <Chip
                    label={previewQuestion.difficulty_level}
                    size="small"
                    color={
                      previewQuestion.difficulty_level === "easy"
                        ? "success"
                        : previewQuestion.difficulty_level === "medium"
                        ? "warning"
                        : "error"
                    }
                    variant="outlined"
                  />
                )}
                <Chip
                  label={`${
                    previewQuestion.question_data?.marks ||
                    previewQuestion.marks ||
                    0
                  } Marks`}
                  size="small"
                  variant="outlined"
                />
              </Box>

              <Divider sx={{ mb: 2 }} />

              {/* Options */}
              {previewQuestion.question_data?.options?.length > 0 && (
                <>
                  <Typography
                    variant="subtitle2"
                    color="text.secondary"
                    mb={1}
                  >
                    Options
                  </Typography>

                  <RadioGroup
                    value={
                      previewQuestion.question_data?.answer?.correct_option ||
                      ""
                    }
                  >
                    {previewQuestion.question_data.options.map((opt, i) => {
                      const isCorrect =
                        opt ===
                        previewQuestion.question_data?.answer?.correct_option;

                      return (
                        <FormControlLabel
                          key={i}
                          value={opt}
                          control={<Radio size="small" color="success" />}
                          label={
                            <Box display="flex" alignItems="center" gap={1}>
                              <Typography fontSize={14}>{opt}</Typography>
                              {isCorrect && (
                                <Chip
                                  label="Correct"
                                  size="small"
                                  color="success"
                                  sx={{ fontSize: 11, height: 20 }}
                                />
                              )}
                            </Box>
                          }
                          sx={{
                            border: "1px solid",
                            borderColor: isCorrect ? "success.main" : "divider",
                            borderRadius: 1,
                            mb: 1,
                            px: 1,
                            mr: 0,
                            bgcolor: isCorrect
                              ? "success.50"
                              : "transparent",
                            transition: "background 0.2s",
                          }}
                        />
                      );
                    })}
                  </RadioGroup>
                </>
              )}
            </>
          )}
        </DialogContent>

        <Divider />

        <DialogActions sx={{ px: 3, py: 2, gap: 1 }}>
          <Button onClick={handleClosePreview} variant="outlined">
            Close
          </Button>
          {previewQuestion && (
            <Button
              variant="contained"
              color={isSelectedInPreview ? "error" : "primary"}
              onClick={handleAddFromPreview}
            >
              {isSelectedInPreview
                ? "Remove from Assessment"
                : "+ Add to Assessment"}
            </Button>
          )}
        </DialogActions>
      </Dialog>
    </Create>
  );
};

export default AssessmentCreate;
